// extracted by mini-css-extract-plugin
export default {"amount-per-serving":"SimplePDPModal-module__amount-per-serving__uaLmD"};